document.addEventListener("DOMContentLoaded", function(){

const cur = document.getElementById('cursor');
const ring = document.getElementById('ring');

if(!cur || !ring) return;

let mx = 0, my = 0, rx = 0, ry = 0;

document.addEventListener('mousemove', e => {
  mx = e.clientX;
  my = e.clientY;
  cur.style.left = mx + 'px';
  cur.style.top = my + 'px';
});

(function loop(){
  rx += (mx - rx) * 0.12;
  ry += (my - ry) * 0.12;
  ring.style.left = rx + 'px';
  ring.style.top = ry + 'px';
  requestAnimationFrame(loop);
})();

document.querySelectorAll('a,button,.cat-btn,.c-item,.dot,.arr-btn')
.forEach(el => {
  el.addEventListener('mouseenter', () => {
    cur.style.width = '18px';
    cur.style.height = '18px';
    ring.style.width = '48px';
    ring.style.height = '48px';
    ring.style.opacity = '1';
  });

  el.addEventListener('mouseleave', () => {
    cur.style.width = '10px';
    cur.style.height = '10px';
    ring.style.width = '32px';
    ring.style.height = '32px';
    ring.style.opacity = '.5';
  });
});

});

document.addEventListener("DOMContentLoaded", function () {

  gsap.from(".animate-fade", {
    opacity: 0,
    y: 50,
    duration: 1,
    stagger: 0.2,
    ease: "power3.out"
  });

});

gsap.registerPlugin(ScrollTrigger);

const panels = document.querySelectorAll(".story-panel");
const dots = document.querySelectorAll(".progress-dot");

panels.forEach((panel, i) => {

  /* text animation */
  gsap.from(panel.querySelector(".story-text"), {
    scrollTrigger: {
      trigger: panel,
      start: "top 70%",
      toggleActions: "play none none reverse"
    },
    y: 60,
    opacity: 0,
    duration: 1
  });

  /* image animation */
  gsap.from(panel.querySelector("img"), {
    scrollTrigger: {
      trigger: panel,
      start: "top 70%",
      toggleActions: "play none none reverse"
    },
    scale: 1.1,
    opacity: 0,
    duration: 1
  });

  /* progress indicator */
  ScrollTrigger.create({
    trigger: panel,
    start: "top center",
    end: "bottom center",
    toggleClass: {
      targets: dots[i],
      className: "active"
    }
  });

});

